import React, { Component } from 'react';
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';
import Notes from 'midi/Notes.js';
import WaveformDropdown from './WaveformDropdown.js';
import PartialCount from './PartialCount.js';
import FMHarmonicityModulation from './FMHarmonicityModulation.js';

class FMParameters extends Component {
    render() {
        let carrier = this.props.instrument.carrierOscillator;
        let modulator  = this.props.instrument.modulatorOscillator;
        return (
            <div className="fm-parameters">
              <div className="oscillator-types">
                <div className="oscillator-type">
                  <WaveformDropdown
                    sequencerEngine={this.props.sequencerEngine}
                    oscillator={modulator}/>
                  <PartialCount oscillator={modulator}/>
                </div>
                <div className="mod-label">mods</div>
                <div className="oscillator-type">
                  <WaveformDropdown
                    sequencerEngine={this.props.sequencerEngine}
                    oscillator={carrier}/>
                  <PartialCount oscillator={carrier}/>
                </div>
              </div>
              <FMHarmonicityModulation
                oscillator={this.props.instrument.carrierOscillator}
                sequencerEngine={this.props.sequencerEngine}
                instrument={this.props.instrument}/>

               <EffectParameterSlider
                  automation={this.props.automation}
                 sequencerEngine={this.props.sequencerEngine}
                  name={'Frequency'}
                  parameter={carrier.oscillatorFrequencyParameter}
                  onParameterChanged={() => carrier.releaseAll()}
                  displayFunction={(x) => Notes.fromTranspose(x).toString()}
                  isParameter={true}
                  min={-32}
                  max={32}
                  step={1}
                  />
              <EffectParameterSlider
                  automation={this.props.automation}
                  name={'Detune'}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  parameter={carrier.detuneParameter}
                  onParameterChanged={() => []}
                  isParameter={true}
                  min={-100}
                  max={100}
                  step={1}
                  />
 
            </div>
        );
    }
}

export default FMParameters;
 
